import { render, staticRenderFns } from "./treasury-kids-form.pug?vue&type=template&id=93a40aac&lang=pug&external"
import script from "./treasury-kids-form.js?vue&type=script&lang=js&external"
export * from "./treasury-kids-form.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports